import Link, { HeaderInfo } from './components/Link';

export const CSVLink = Link;
export type { HeaderInfo };
